// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"lE","controlPlay":"lF","controlElement":"lG","lowerControlWrapper":"lH","lowerControlIconWrapper":"lI","lowerControlIcon":"lJ","show":"lK"};